/** Keys in their original LaunchDarkly form, so Code References and a plain grep both resolve. */

export const LD_FLAG_USE_TASK_SYSTEM = 'use-task-system';

export const LD_FLAG_ENABLE_SESSION_REPLAY = 'enable-session-replay';

export const LD_FLAG_ENABLE_DEV_TOOLBAR = 'enable-dev-toolbar';

export const LD_FLAG_DATA_CHANGE_LOG = 'data-change-log';

export const LD_FLAG_ENABLE_QUICKSIGHT_REPORTS = 'enable-quicksight-reports';
